module.exports = __webpack_public_path__ + "img/1493442682.c8fc6000.jpg";